import { CLOSED_WITH_BALANCE, DELINQUENT, OPEN } from "../const/products";
/**
 * This function checks various conditions to check to display the autopay button or not.
 * It handles both DCE and legacy conditions through the `isDCEEnabled` flag
 * For DCE:
 * - One of these must be true: condition is open, condition is closed with balance, or on a customer assistance plan
 * - Settlement must NOT be enrolled.
 *
 * For legacy:
 * - The condition must be open or closed with balance AND enrolled in a customer assistance plan / settlement plan
 * - Must not be past due and not be delinquent
 *
 * @param isPastDue - boolean value representing past due loan
 * @param conditions - array of conditions related to account
 * @param customerAssistancePlan - boolean value
 * @param settlementEnrolled  - boolean value that checks whether account is in a settlement or not
 * @param isDCEEnabled - boolean value that controls whether or not DCE logic used
 * @param isAutopayStatusUndefined - boolean value that must be false for button to show
 * @param isAutopayButtonVisible - boolean value that must be true for button to show
 * @param isRegistered - boolean value if user has registered account
 * @param hasAutopayCallback - boolean value to see if there is a callback necessary to show the autopay button
 * @returns a boolean flag representing to show the autopay button or not.
 */
export var showAutopayButton = function (_a) {
    var isPastDue = _a.isPastDue, conditions = _a.conditions, customerAssistancePlan = _a.customerAssistancePlan, settlementEnrolled = _a.settlementEnrolled, isDCEEnabled = _a.isDCEEnabled, isAutopayStatusUndefined = _a.isAutopayStatusUndefined, isAutopayButtonVisible = _a.isAutopayButtonVisible, isRegistered = _a.isRegistered, hasAutopayCallback = _a.hasAutopayCallback;
    var isOpen = conditions === null || conditions === void 0 ? void 0 : conditions.includes(OPEN);
    var isClosedWithBalance = conditions === null || conditions === void 0 ? void 0 : conditions.includes(CLOSED_WITH_BALANCE);
    var isDelinquent = conditions === null || conditions === void 0 ? void 0 : conditions.includes(DELINQUENT);
    var isEnrolled = customerAssistancePlan || settlementEnrolled;
    var legacyAutopayDisplayCondition = !isPastDue &&
        !((isOpen || isClosedWithBalance) && isEnrolled) &&
        !isDelinquent;
    var currentAutopayDisplayCondition = (isOpen || isClosedWithBalance || customerAssistancePlan) &&
        !settlementEnrolled;
    var autopayDisplayCondition = isDCEEnabled
        ? currentAutopayDisplayCondition
        : legacyAutopayDisplayCondition;
    return Boolean(!isAutopayStatusUndefined &&
        isAutopayButtonVisible &&
        autopayDisplayCondition &&
        isRegistered &&
        hasAutopayCallback);
};
//# sourceMappingURL=showAutopayButton.js.map